<template>
    <v-row>
        <v-col sm="12" xs="12"  md="8" lg="8">
            <v-hover v-slot="{ hover }">
                <div class="box" @click="goToProject(projects[0].id)">
                    <v-img
                    class="grayscale"
                    height="71vh"
                    :src="getImage(projects[0])"
                    >
                        <v-expand-transition>
                            <div
                                v-if="hover || mobile" 
                                class="d-flex transition-fast-in-fast-out v-card--reveal white--text text-center hover-text"
                            >
                                {{language=='Ελληνικά'? projects[0].title : projects[0].titleEn}}
                            </div>
                        </v-expand-transition>
                    </v-img>
                </div>
            </v-hover>
        </v-col>
        <v-col v-if="projects[1]" md="4" sm="12" xs="12" lg="4">
            <div>
                <v-hover v-slot="{ hover }">
                    <div class="box" @click="goToProject(projects[1].id)">
                        <v-img
                        class="grayscale"
                        height="34vh"
                        :src="getImage(projects[1])"
                        >
                            <v-expand-transition>
                                <div
                                    v-if="hover || mobile"
                                    class="d-flex transition-fast-in-fast-out v-card--reveal white--text text-center"
                                >
                                    {{language=='Ελληνικά'? projects[1].title : projects[1].titleEn}}
                                </div>
                            </v-expand-transition>
                        </v-img>
                    </div>
                </v-hover>
                <v-hover v-slot="{ hover }">
                    <div v-if="projects[2]" class="box mt-7" @click="goToProject(projects[2].id)">
                        <v-img
                        class="grayscale"
                        height="34vh"
                        :src="getImage(projects[2])"
                        >
                            <v-expand-transition>
                                <div
                                    v-if="hover || mobile"
                                    class="d-flex transition-fast-in-fast-out v-card--reveal white--text text-center"
                                >
                                    {{language=='Ελληνικά'? projects[2].title : projects[2].titleEn}}
                                </div>
                            </v-expand-transition>
                        </v-img>
                    </div>
                </v-hover>
            </div>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props: {
            projects: Array,
            language: String,
            available: Boolean
        },
        data() {
            return {
            }
        },
        computed: {
            mobile() {
                return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm
            },
        },
        methods: {
            goToProject(id) {
                this.$router.push({name: 'Project', query: { projectId: id, available: this.available }});
            },
            getImage(project) {
                var images = project.images.length
                if(images > 0) {
                    var catalogMain = project.images.filter(element => element.description === "catalog_main")
                    if (catalogMain.length > 0) {
                        return `https://dev.aggelopoulos-sarantis.com/uploads/images/${catalogMain[0].imageName}`
                    } else {
                        return `https://dev.aggelopoulos-sarantis.com/uploads/images/${project.images[0].imageName}`
                    }
                } else {
                    return require("@/assets/coming soon.png")
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .box{
        position: relative;
    }

    .grayscale{
        filter: grayscale(0%);
    }

    .grayscale:hover {
        transition: 0.3s ease-in-out; 
        filter: grayscale(100%);
    }


    .v-card--reveal {
        align-items: center;
        bottom: 0;
        justify-content: center;
        position: absolute;
        width: 100%;
        height: auto; 
        font-size: 3vh; 
        background: rgba(66, 66, 66, 0.6);

    }

    @media only screen and (max-width: 600px){
        .grayscale{
            height: 60vh !important;
            filter: grayscale(0%);
        }
    }

</style>